/**
 * Read JWT claims without verifying the signature.
 * Login already accepted the token; we only need flags the backend embeds.
 */

function decodeBase64Url(value) {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
  const binary = atob(padded);
  if (typeof TextDecoder === 'function') {
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new TextDecoder().decode(bytes);
  }
  return binary;
}

export function readAccessTokenClaims(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length < 2 || !parts[1]) return null;
  try {
    return JSON.parse(decodeBase64Url(parts[1]));
  } catch {
    return null;
  }
}

export function makeAccessToken(payload) {
  const json = JSON.stringify(payload);
  const base64 = btoa(json).replace(/=+$/, '');
  return `header.${base64}.sig`;
}
